import { useGlobal } from '../../global/useGlobal'
import { usePromise } from './usePromise'
import { getConstructionData } from '../../services/main/getConstructionData'
import { useEffect, useState } from 'react'
import { getConstructionData_listUserSaleContracts } from '../../services/types/getConstructionData'

export const useConstructionData = () => {
  const [constructionProgressData] = useGlobal('constructionData')
  const [selectedConstruction] = useGlobal('selectedUserSaleContract')
  const [data, setData] = useState<getConstructionData_listUserSaleContracts>()

  const { loading: isFetchingConstructionData, request: fetchConstructionProgress } = usePromise(getConstructionData)

  useEffect(() => {
    fetchConstructionProgress()
  }, [])

  useEffect(() => {
    if (constructionProgressData) {
      setData(
        constructionProgressData.find(
          datum => `${datum.construction.name} - ${datum.constructionUnit.name}` === selectedConstruction.text
        )
      )
    }
  }, [constructionProgressData, selectedConstruction])

  return {
    constructionData: data,
    isFetchingConstructionData: isFetchingConstructionData,
  }
}
